export const ROOT_PATH = "";
export const HOME_PATH = "home";
export const ABOUT_PATH = "about";
